// Helpers to pull key application answers for outreach context.

export const getAnswer = (p, includes) => {
  const a = (p.typeform_answers || []).find(
    (qa) => (qa.question || "").toLowerCase().includes(includes)
  );
  return a && a.answer ? String(a.answer) : "";
};

export const painPoint = (p) => getAnswer(p, "off your plate");
export const revenueBand = (p) => getAnswer(p, "monthly revenue");
